import React from "react";
import { Navigate, useRoutes } from 'react-router-dom';

import { paths } from '../paths';
import { authRoutes } from "./auth";
import { mainRoutes } from "./main";
import { dashboardRoutes } from './dashboard';
import LandingLayout from "../../layout/LandingLayout";
import { LoadingScreen } from '../../components/loading-screen';
import { useMonteflor } from '../../hooks/useMonteflor.context';
const HomePage = React.lazy(() => import('../../pages/landing/faq'));

// ----------------------------------------------------------------------

// Componente para manejar la ruta raíz
function LandingPageOrRedirect() {
  const { isAuthenticated, isLoading } = useMonteflor();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Si está autenticado, redirigir al panel
  if (isAuthenticated) {
    return <Navigate to={paths.panel.root} replace />;
  }

  // Si no está autenticado, mostrar landing page
  return (
    <LandingLayout>
      <HomePage />
    </LandingLayout>
  );
}

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Landing page - ruta pública por defecto con lógica de redirección
    {
      path: '/',
      element: <LandingPageOrRedirect />,
    },

    // Rutas de autenticación
    ...authRoutes,

    // Rutas del panel/dashboard (protegidas)
    ...dashboardRoutes,

    // Rutas principales (errores, etc.)
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
]);
}
